module.exports = __webpack_public_path__ + "static/media/076-suriname.95bf4a76.svg";